import { render } from "./MusicUnixSystem.vue?vue&type=template&id=13b872e8&scoped=true"
import script from "./MusicUnixSystem.vue?vue&type=script&lang=js"
export * from "./MusicUnixSystem.vue?vue&type=script&lang=js"

import "./MusicUnixSystem.vue?vue&type=style&index=0&id=13b872e8&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13b872e8"]])

export default __exports__